import { InputHTMLAttributes, forwardRef, ReactNode } from "react";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  icon?: ReactNode;
  inputSize?: "sm" | "md" | "lg";
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className = "", error, icon, inputSize = "md", ...props }, ref) => {
    const sizeClasses = {
      sm: "h-10 px-3 text-sm",
      md: "h-11 px-4 text-sm",
      lg: "h-12 px-5 text-base",
    };

    return (
      <div className="flex flex-col gap-1 w-full">
        <div className="relative flex items-center w-full">
          {icon && (
            <div className="absolute left-3.5 text-muted pointer-events-none flex items-center justify-center">
              {icon}
            </div>
          )}
          <input
            ref={ref}
            className={`flex w-full rounded-lg border bg-surface px-4 py-2 text-main transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-synaptix-cyan focus-visible:border-synaptix-cyan disabled:cursor-not-allowed disabled:opacity-50 ${
              sizeClasses[inputSize]
            } ${
              error
                ? "border-red-500/50 focus-visible:ring-red-500"
                : "border-border"
            } ${icon ? "pl-10" : ""} ${className}`}
            {...props}
          />
        </div>
        {error && <span className="text-xs text-red-400 font-medium">{error}</span>}
      </div>
    );
  }
);

Input.displayName = "Input";

